import React from 'react'
import { BaseSensitiveMessageSummary } from '../../commonComponents/CommonComponents'

export default () => {}

export function HybridSensitiveMessageSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  return (
    <BaseSensitiveMessageSummary
      messageDetails={messageDetails}
      queueCachesState={queueCachesState}
      queueCachesActions={queueCachesActions}
      labelsBlockProps={{}}
    />
  )
}
